<template>
<div class="Main">
  <nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <router-link to="/" class="navbar-item">
        <img src="@/assets/img/logo.png" alt="logo cayros">
        <h2>Cayros School</h2>
      </router-link>
      <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>
    <div id="navbarBasicExample" class="navbar-menu">
      <div class="navbar-end">
        <div class="navbar-item">
          <div class="buttons">
            <a class="button is-rounded  is-text" @click="logout()">
              Salir
            </a>
          </div>
        </div>
      </div>
    </div>
  </nav>
  <HeaderSlider />
  <Notice />
  <Info />
  <Images />
  <Videos />
  <Events />
  <!-- <Teachers /> -->
  <Messages />
</div>
</template>

<script>
import Notice from '@/components/admin/Notice'
import Info from '@/components/admin/Info'
import Events from '@/components/admin/Events'
import Images from '@/components/admin/Images'
import Videos from '@/components/admin/Videos'
import HeaderSlider from '@/components/admin/HeaderSlider'
import Messages from '@/components/admin/Messages'
// import Teachers from '@/components/admin/Teachers'
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  components: { HeaderSlider, Events, Images, Videos , Messages, Info, Notice },
  methods: {
    logout () {
      firebase.auth().signOut().then(() => {
        this.$router.replace('/')
      }).catch((error) => {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="sass" scoped>
@import "bulma"
@import '../assets/css/_variables.sass'
.Main
  font-family: $font_text
  .button
    box-sizing: border-box
  nav
    box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1), 0 0px 0 1px rgba(10, 10, 10, 0.02)
    h2
      font-weight: 700
      margin-left: 15px
  .container
    h1
      font-size: 20px
    table
      width: 100%
</style>